import React, { createContext, useContext, ReactNode } from "react";
import {
  useGeolocationPermissions,
  UseGeolocationPermissionsReturn,
} from "@/hooks/useGeolocationPermissions";

const GeolocationContext = createContext<
  UseGeolocationPermissionsReturn | undefined
>(undefined);

interface GeolocationProviderProps {
  children: ReactNode;
}

export const GeolocationProvider: React.FC<GeolocationProviderProps> = ({
  children,
}) => {
  const geolocationData = useGeolocationPermissions();

  return (
    <GeolocationContext.Provider value={geolocationData}>
      {children}
    </GeolocationContext.Provider>
  );
};

export const useGeolocationContext = (): UseGeolocationPermissionsReturn => {
  const context = useContext(GeolocationContext);
  if (context === undefined) {
    throw new Error(
      "useGeolocationContext must be used within a GeolocationProvider",
    );
  }
  return context;
};
